export * from '@fluentui/font-icons-mdl2';
//# sourceMappingURL=Icons.js.map